import { OrdemCompra } from "../../components/ordemCompra/OrdemCompra";

export const OrdemCompraPage = () => {
  return (
    <div style={{
      margin: "auto"
    }}>
      <OrdemCompra />
    </div>
  );
};
